import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { ListYourMachinesLayoutComponent } from "./list-your-machines-layout/list-your-machines-layout.component";
import { ListYourMachinesHeaderComponent } from "./list-your-machines-header/list-your-machines-header.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ListYourMachinesSupportComponent } from "./list-your-machines-support/list-your-machines-support.component";
import { ListYourMachinesPeaceComponent } from "./list-your-machines-peace/list-your-machines-peace.component";
import { ListYourMachinesProfitComponent } from "./list-your-machines-profit/list-your-machines-profit.component";
import { ListYourMachinesManageComponent } from "./list-your-machines-manage/list-your-machines-manage.component";
import { ListYourMachinesGetPaidComponent } from "./list-your-machines-get-paid/list-your-machines-get-paid.component";
import { ListYourMachinesWeHandleComponent } from "./list-your-machines-we-handle/list-your-machines-we-handle.component";
import { SearchResultsModule } from "@rubbl-search-results";
import { MarketingModule } from "@rubbl-marketing";
import { LayoutModule } from "@rubbl-layout";

export const routes: Routes = [
  {
    path: "",
    component: ListYourMachinesLayoutComponent,
    data: {
      keywords: "fleet equipment rental/s fleet equipment management",
      description:
        "Rubbl - we connect your idle heavy machinery to contractors in the marketplace. Don't waste time and money with an idle fleet, earn more revenue now. Learn more",
      title: "Construction Fleet Equipment Rentals",
    },
  },
];

@NgModule({
  declarations: [
    ListYourMachinesLayoutComponent,
    ListYourMachinesHeaderComponent,
    ListYourMachinesProfitComponent,
    ListYourMachinesPeaceComponent,
    ListYourMachinesSupportComponent,
    ListYourMachinesPeaceComponent,
    ListYourMachinesManageComponent,
    ListYourMachinesGetPaidComponent,
    ListYourMachinesWeHandleComponent,
  ],
  imports: [CommonModule, RouterModule.forChild(routes), FormsModule, ReactiveFormsModule, MarketingModule, SearchResultsModule, LayoutModule],
})
export class ListYourMachinesModule {}
